<template>
    <el-upload
        class="file-upload"
        :action= "imgModel ? '/api/file/upload/compress' :' /api/file/upload/cos'"
        :before-upload="bfupload"
        :file-list.sync="ifiles"
        :on-remove="oremove"
        :before-remove="bRemove"
        :data="params"
        :on-success="uploaded"
        :show-file-list="showList"
        :on-preview="download"
        :disabled="disabled"
        :on-progress="oprogress"
    >
        <slot></slot>
        <el-button ize="mini" type="primary" v-if="!disabled && !$slots.default">{{ title }}</el-button>
    </el-upload>
</template>
<script>
export default {
    props: {
        disabled: { type: Boolean, default: false },
        showList: { type: Boolean, default: true },
        files: { type: Array, default: null },
        userId: { type: [Number, String], default: null },
        relateId: { type: [Number, String], default: null },
        relateType: { type: String, default: null },
        title: { type: String, default: "上传文件" },
        imgModel : { type: Boolean, default: false },
        imgSize: { type: String, default: null },
        uploadedCallback: { type: Function, default: null },
        deleteCallback: { type: Function, default: null },
        progressCallback: { type: Function, default: null },
        beforeUpload:  { type: Function, default: null },
    },
    data() {
        return {
            ifiles: [],
            params: {},
        };
    },
    methods: {
        bRemove(file, fileList) {
            if (file.creator != this.$cookies.get('U_ID')) {
                this.$message({
                    message: "只能删除自己上传的文件！",
                    type: "warning",
                });
                return false;
            } else {
                return this.$confirm(`确定移除 ${file.name}？`);
            }
        },
        oremove(file, fileList) {
            for (var i in this.ifiles) {
                if (this.ifiles[i].name == file.name) {
                    this.ifiles.splice(i, 1);

                    if (file.id) {
                        this.doRemove(file.id);
                    }
                }
            }
        },
        uploaded(response, file, fileList) {
            let _file = {
                name: file.name,
                size: file.size,
                address: response.data.address,
                id: response.data.id,
                creator: response.data.creator,
                contentType: response.data.contentType,
                base64: response.data.base64
            };

            this.ifiles.unshift(_file);
            this.$emit("update:files", this.ifiles);

            if (this.uploadedCallback) {
              this.uploadedCallback(this.ifiles, _file);
            }
        },
        bfupload(file) {
            if (this.beforeUpload) {
                this.beforeUpload(file);
            }

            if (this.relateId) {
                this.params["relateId"] = this.relateId;
            }

            if (this.relateType) {
                this.params["relateType"] = this.relateType;
            }

            if (this.imgModel) {
              this.params["imgSize"] = this.imgSize;
            }

            return true;
        },
        doRemove(id) {
            let _this = this;

            _this.$http.post(["file/delete", { id: id }], [ function(data, msg) {
                if (_this.deleteCallback) {
                    _this.deleteCallback(data, msg);
                } else {
                    msg();
                }
            }], ".file-upload");
        },
        download(file) {
            if (file.id) {
                window.open("/api/file/download/byId?id=" + file.id, "_blank");
            } else {
                this.$message({
                    message: "还未保存，无法下载",
                    type: "warning",
                });
            }
        },
        oprogress(event, file, fileList) {
            if (this.progressCallback) {
                this.progressCallback(event);
            }
        }
    },
    watch: {
        files(val) {
            this.ifiles = val ? val : [];
        },
    },
    mounted() {
        this.ifiles = this.files ? this.files : [];
    }
};
</script>

<style lang="scss" scoped>
.el-upload-list {
    max-height: 100px;
    overflow: auto;
}
</style>